import React from 'react';
import useLocalisation from '../../hooks/useLocalisation';
import * as classes from './BookingSummary.module.css';
import { useCart } from '../../context/shopContext';
import PropTypes from 'prop-types';

const BookingSummary = ({ paid, items = [], language = 'fi' }) => {
  const { localize, toLocalisationKey } = useLocalisation(language);

  /**
    items param only contains a single item selected in the widget and it's state is cleared on add to cart,
    so to display all items in the summary the line items from cart need to be extracted from the checkout object
   */
  const { checkout } = useCart();
  const lineItems =
    checkout && checkout.lineItems.length ? checkout.lineItems : null;

  let cart = [];
  if (lineItems) {
    cart = lineItems.reduce((acc, curr) => {
      return [
        ...acc,
        {
          name: curr.title,
          amount: curr.quantity,
          value: 'custom',
          price: parseFloat(curr.variant.price.amount),
          key: curr.id,
        },
      ];
    }, []);
  }

  const combinedItems = [...cart, ...items];

  const calculateTotal = () =>
    combinedItems.reduce((total, curr) => {
      const price = curr.amount * curr.price;
      return total + price;
    }, 0);

  return (
    <div className={classes.summary}>
      <h5>{localize('SUMMARY_TITLE')}</h5>
      {!!combinedItems.length ? (
        <ul className={classes.list}>
          {combinedItems.map((item) => (
            <li key={item.key} style={{ display: 'flex' }}>
              <span style={{ flex: 1 }}>
                {item.amount} x{' '}
                {item.value == 'custom'
                  ? item.name
                  : localize(toLocalisationKey(item.name))}
              </span>
              {item.price !== '0.00' ? (
                <span>{item.price} €</span>
              ) : (
                <span>-</span>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p className={classes.empty}>{localize('NO_SELECTED_ITEMS')}</p>
      )}
      <div style={{ marginTop: '3rem' }}>
        <h5>
          {localize('TOTAL')}:{' '}
          {paid
            ? `${calculateTotal(combinedItems).toFixed(2)} €`
            : localize('PREORDER')}
        </h5>
      </div>
    </div>
  );
};

export default BookingSummary;

BookingSummary.propTypes = {
  paid: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  language: PropTypes.string.isRequired,
};
